(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-hulkapps-backup"]) return;
  try {
    
  function EvDebounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  if (!customElements.get('gift-message')) {
    customElements.define('gift-message', class GiftMessage extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', EvDebounce((event) => {
            const attrVal = event.target.checked ? "Yes" : "No"; 
            const body = JSON.stringify({ attributes: {"giftmessage": attrVal}});
            const fetchConfig = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/json`,
              }
            };
            fetch(`${theme.routes.cart_url}`, {
              ...fetchConfig,
              ...{ body },
            });
        }, 300))
      }
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function EvDebounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  if (!customElements.get('gift-message')) {
    customElements.define(
      'gift-message',
      class GiftMessage extends HTMLElement {
        constructor() {
          super();
          this.addEventListener(
            'change',
            EvDebounce((event) => {
              const attrVal = event.target.checked ? 'Yes' : 'No';
              const body = JSON.stringify({ attributes: { giftmessage: attrVal } });
              const fetchConfig = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: `application/json`,
                },
              };
              fetch(`${theme.routes.cart_url}`, {
                ...fetchConfig,
                ...{ body },
              });
            }, 300)
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
class collectionGridBanner extends HTMLElement {
    constructor() {
        super();
        const products = document.querySelectorAll('.product-list .product-block');
		const position = parseInt( this.dataset.position );
		const _this 	= this;
		products.forEach(function(product,index){
			index += 1;
			if( position === index ){
                product.parentNode.insertBefore( _this.querySelector('.collection_grid_banner'), product );
				return false;
			}
		});
		this.remove();
    }
}
customElements.define('grid-banner', collectionGridBanner);
class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      
      this.productsGrid 	= document.querySelector('.collection-listing .product-list');
      this.loading 		= this.querySelector('.loading-overlay');
  
      if ( this.querySelector('a') ) this.querySelector('a').remove();
  
      if ( !this.productsGrid ) return;
  
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }
        this.loading.classList.remove('hidden');

        document.querySelector('.filter-container[data-ajax-container]').classList.add('ajax-loading');
  
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {

              const html = document.createElement('div');
              html.innerHTML = text;
              const products = html.querySelector('.collection-listing .product-list');
              const infinite = html.querySelector('infinite-scroll');
  
              if ( products && products.innerHTML.trim().length ) {
                this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
              }
              // load content
              theme.ProductBlockManager.unloadImages($('.collection-listing .product-list'));
              theme.ProductBlockManager.loadImages($('.collection-listing .product-list'))
              // init theme components
              var $componentHaver = $('.collection-listing .product-list').closest('[data-components]');
              if ($componentHaver) {
                var components = $componentHaver.data('components').split(',');
                components.forEach(function (component) {
                  $(document).trigger('cc:component:load', [component, $componentHaver[0]]);
                });
              }
              // init scroll animations
              theme.initAnimateOnScroll();
              // wishlist
              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
              if( infinite ){
                this.dataset.url = infinite.dataset.url;
              }else{
                observer.unobserve(this);
              }
              this.loading.classList.add('hidden');
              document.querySelector('.filter-container[data-ajax-container]').classList.remove('ajax-loading');
            })
          .catch(e => {
            this.loading.classList.add('hidden');
            document.querySelector('.filter-container[data-ajax-container]').classList.remove('ajax-loading');
            console.error(e);
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
}
customElements.define('infinite-scroll', InfiniteScroll);

document.addEventListener('DOMContentLoaded', function() {
	const scrollDown = document.querySelector('.button--page-scroll[data-direction="down"]');
	const scrollUp = document.querySelector('.button--page-scroll[data-direction="up"]');
	const footer = document.querySelector("#shopify-section-footer");

	if( footer && scrollDown ) {
		new IntersectionObserver(function( entries ){
			if (entries[0].isIntersecting) {
				scrollDown.classList.add('hidden')
			}else{
				scrollDown.classList.remove('hidden')
			}
		}, {
			threshold: 0.1
		}).observe( footer );
		scrollDown.addEventListener('click', function(){
			window.scroll({top: footer.offsetTop, left: 0, behavior: 'smooth'});
		});
	}
	scrollUp.addEventListener('click', function(){
		window.scroll({top: 0, left: 0, behavior: 'smooth'})
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      
      this.productsGrid 	= document.querySelector('.collection-listing .product-list');
      this.loading 		= this.querySelector('.loading-overlay');
  
      if ( this.querySelector('a') ) this.querySelector('a').remove();
  
      if ( !this.productsGrid ) return;
  
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }
        this.loading.classList.remove('hidden');

        document.querySelector('.filter-container[data-ajax-container]').classList.add('ajax-loading');
  
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {

              const html = document.createElement('div');
              html.innerHTML = text;
              const products = html.querySelector('.collection-listing .product-list');
              const infinite = html.querySelector('infinite-scroll');
  
              if ( products && products.innerHTML.trim().length ) {
                this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
              }
              // load content
              theme.ProductBlockManager.unloadImages($('.collection-listing .product-list'));
              theme.ProductBlockManager.loadImages($('.collection-listing .product-list'))
              // init theme components
              var $componentHaver = $('.collection-listing .product-list').closest('[data-components]');
              if ($componentHaver) {
                var components = $componentHaver.data('components').split(',');
                components.forEach(function (component) {
                  $(document).trigger('cc:component:load', [component, $componentHaver[0]]);
                });
              }
              // init scroll animations
              theme.initAnimateOnScroll();
              // wishlist
              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
              if( infinite ){
                this.dataset.url = infinite.dataset.url;
              }else{
                observer.unobserve(this);
              }
              this.loading.classList.add('hidden');
              document.querySelector('.filter-container[data-ajax-container]').classList.remove('ajax-loading');
            })
          .catch(e => {
            this.loading.classList.add('hidden');
            document.querySelector('.filter-container[data-ajax-container]').classList.remove('ajax-loading');
            console.error(e);
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
}
customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
